import { render, staticRenderFns } from "./AffiliateList.vue?vue&type=template&id=5d96b514&scoped=true"
import script from "./AffiliateList.vue?vue&type=script&lang=js"
export * from "./AffiliateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d96b514",
  null
  
)

export default component.exports